module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "id": "informator"
    }
  }, [_vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "green ti-check"
  }), _c('br'), _vm._v("Успешно")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee05ae90","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/Informator.vue
// module id = 119
// module chunks = 0